/**
 * Client-side working day calculation — mirrors api/shared/dayCalculation.js
 */
export function calculateWorkingDays(startDate, endDate, workingDays, holidays, halfDay) {
  const holidaySet = new Set(holidays || []);
  const start = new Date(startDate + 'T00:00:00');
  const end = new Date(endDate + 'T00:00:00');

  if (start > end) return 0;

  let count = 0;
  let firstWorkingDay = null;
  let lastWorkingDay = null;
  const current = new Date(start);

  while (current <= end) {
    const dayOfWeek = current.getDay();
    const dateStr = current.toISOString().substring(0, 10);

    if (workingDays.includes(dayOfWeek) && !holidaySet.has(dateStr)) {
      count++;
      if (firstWorkingDay === null) firstWorkingDay = dateStr;
      lastWorkingDay = dateStr;
    }

    current.setDate(current.getDate() + 1);
  }

  if (halfDay === 'start' && firstWorkingDay !== null) count -= 0.5;
  if (halfDay === 'end' && lastWorkingDay !== null) count -= 0.5;

  return Math.max(0, count);
}
